<form [formGroup]="inputForm">
  <section>
    <h3>Umsatzsteuer</h3>
    <form-row>
      <mat-radio-group
        aria-label="fixing-type"
        class="radio-group"
        fxLayout="column"
        formControlName="ustPflichtig"
        (change)="taxMandatoryChanged($event)">
        <mat-radio-button class="radio-button" [value]="true">
          Ich / Wir erkläre(n) hiermit, dass ich / wir als Unternehmer dem Umsatzsteuergesetz (UStG)
          unterliege(n) und - so- weit einschlägig - auf die Anwendung der Kleinunternehmerregelung nach § 19
          UStG verzichte(n).
        </mat-radio-button>
        <mat-radio-button class="radio-button" [value]="false">
          Ich / Wir erkläre(n) hiermit, dass ich / wir dem Umsatzsteuergesetz nicht unterliege(n) bzw.
          Kleinunternehmer im Sinne des § 19 UStG bin / sind. Die Umsatzsteuer für die Einspeisung wird in
          diesem Fall durch den Netzbetreiber nicht abgerechnet.
        </mat-radio-button>
        <mat-error *ngIf="!inputForm.get('ustPflichtig').valid && inputForm.get('ustPflichtig').touched">
          Bitte wählen Sie eine Option zur Umsatzsteuerpflicht aus
        </mat-error>
      </mat-radio-group>
    </form-row>
  </section>

  <section *ngIf="checkIfMandatory()">
    <form-row>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Steuernummer</mat-label>
        <input matInput type="text" formControlName="ustNr" />
        <mat-error
          *ngIf="
            (inputForm.get('ustNr').touched || inputForm.get('taxNr').touched) &&
            inputForm.get('ustPflichtig').value &&
            !inputForm.get('ustNr').value &&
            !inputForm.get('taxNr').value
          ">
          Steuernummer bzw. Umsatzsteueridentifikationsnummer ist erforderlich
        </mat-error>
      </mat-form-field>
    </form-row>

    <form-row>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Umsatzsteueridentifikationsnummer (nur wenn zugeteilt)</mat-label>
        <input matInput type="text" formControlName="taxNr" />
      </mat-form-field>
    </form-row>

    <!-- ToDo: Gonzalo: Logik zum Besteuerungsteil -->
    Die Besteuerung der Umsätze erfolgt nach folgenden Bestimmungen:
    <form-row>
      <mat-radio-group
        aria-label="fixing-type"
        class="radio-group"
        fxLayout="column"
        formControlName="steuerArt">
        <mat-radio-button class="radio-button" [value]="'1'">
          Regelbesteuerung gemäß § 12 UStG (19% - Stand 01.01.2007)
        </mat-radio-button>
        <mat-radio-button class="radio-button" [value]="'2'">
          Besteuerung als land- und forstwirtschaftlicher Betrieb gemäß Sondervorschrift § 24 UStG
          <br />
          (i. d. R. nur bei Biomasseanlagen)
        </mat-radio-button>
        <mat-radio-button class="radio-button" [value]="'3'">
          Besteuerung als Wiederverkäufer/Reverse-Change-Verfahren im Sinne des § 3g UStG
        </mat-radio-button>
      </mat-radio-group>
    </form-row>
  </section>

  <section *ngIf="checkIfMandatory() === false">
    <form-row>
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>Steueridentifikationsnummer</mat-label>
        <input matInput type="text" formControlName="customerTaxIdentificationNumber" />
        <mat-error
          *ngIf="
            inputForm.get('customerTaxIdentificationNumber').touched &&
            inputForm.get('customerTaxIdentificationNumber').invalid
          ">
          Steueridentifikationsnummer ist erforderlich
        </mat-error>
      </mat-form-field>
    </form-row>
  </section>

  <section>
    <form-row>
      <app-accept-conditions
        [inputForm]="inputForm"
        [controlName]="'acceptedUstConditions'"
        [disable]="disableConditions"
        [inputLink]=""
        [inputText]="
          'Ich / Wir verpflichte(n) mich / uns, jede Änderung meiner / unserer umsatzsteuerlichen Verhältnisse dem Netzbetreiber unverzüglich schriftlich mitzuteilen.<br/>' +
          'Ich / Wir ersetze(n) dem Netzbetreiber seinen Aufwand für jede Rechnungsänderungen, die aus einer verspäteten und/oder aus einer Änderung meiner / unserer umsatzsteuerlichen Verhältnisse, ' +
          'und/oder aus dem nicht mitgeteilten Vorliegen meiner/unserer Wiederverkäufereigenschaft nach dem UStG resultiert.<br/>' +
          'Insbesondere werde(n) ich / wir eine nach den Vorschriften des Umsatzsteuergesetzes unberechtigt ausgewiesene und vom Netzbetreiber ausbezahlte Umsatzsteuer entsprechend der Regelung unter Ziffer 4.8 zurückerstatten.'
        "></app-accept-conditions>
    </form-row>
  </section>
</form>
